import globalTheme from '../global'

const Stepper = {
	MuiStepIcon: {
		styleOverrides: {
			root: {
				color: globalTheme.palette.primary.contrastText,
			},
		},
	},
	MuiStepLabel: {
		styleOverrides: {
			root: {
				'&.Mui-disabled': {
					pointerEvents: 'none',
					'& .MuiStepLabel-iconContainer': {
						'& > p': {
							borderColor: globalTheme.palette.grey.light,
							backgroundColor: globalTheme.palette.grey.light,
							color: globalTheme.palette.grey.medium,
						},
					},
				},
			},

			iconContainer: {
				cursor: 'inherit',
				'& > p': {
					'&:hover': {
						borderColor: globalTheme.palette.primary.main,
						transition: 'border-color .3s',
						transitionTimingFunction: globalTheme.transitions.easing.easeOut,
					},
				},
			},
			label: {
				marginTop: '24px',
				'&.MuiStepLabel-alternativeLabel': {
					marginTop: '24px',
				},
			},
		},
	},
	MuiStepConnector: {
		styleOverrides: {
			root: {
				top: '24px',
			},
			line: {
				borderColor: globalTheme.palette.grey.light,
			},
		},
	},
}

export default Stepper
